import { useEmbarcacaoClasse } from "../../../../hooks/use-embarcacao-classe";
import { EMPTY_FIELD_PLACEHOLDER, latestAtualizacao } from "../../../detail-format/detail-format";
import { buildDetailFields } from "../../../detail-format/detail-fields";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  CLASSE_EMPTY_STATE,
  CLASSE_FIELDS,
  CLASSE_ID,
  CLASSE_LOADING_MESSAGE,
  CLASSE_TEST_ID,
  CLASSE_TITLE,
} from "./classe-section.constants";

/** Seção Classe do detalhamento da embarcação, somente para consulta: campos já formatados na ordem da tela; campo sem valor mostra "Campo sem preenchimento". */
export function useClasseSection({ embarcacaoId, onReauthenticate }: EmbarcacaoDetailSectionProps) {
  const { status, classe, errorMessage, reload } = useEmbarcacaoClasse(embarcacaoId);

  return {
    id: CLASSE_ID,
    title: CLASSE_TITLE,
    testId: CLASSE_TEST_ID,
    fieldsTestId: `${CLASSE_TEST_ID}-fields`,
    status,
    errorMessage,
    loadingMessage: CLASSE_LOADING_MESSAGE,
    emptyContent: CLASSE_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem dados.
    ultimaAtualizacao: classe
      ? latestAtualizacao([classe.ultimaAtualizacao, classe.atualizacaoClasse])
      : undefined,
    fields: buildDetailFields(classe, CLASSE_FIELDS, CLASSE_TEST_ID, EMPTY_FIELD_PLACEHOLDER),
  };
}
